import React from 'react';
import client from '../../../Assets/client-main.svg';
import comment from '../../../Assets/commentBx.png';
import './Clients.css';

const Clients = () => {
    return (
        <div className='container p-md-5'>
            <div className="clients-area text-md-center">
                <h1 className='theme-font py-2'> What Our Customers Says</h1>
                <h6>Our community of talents helped grow start-ups, small bussinesses and mulinational corporations.Take a looks ata the clients who took a chance to us!</h6>
            </div>
            <div className="row m-md-5 d-flex justify-content-between">
                <div className="col-md-4 col-12">
                    <img className='clients-img' src={client} alt="" />
                </div>
                <div className="col-md-8 col-12">
                    <div id="carouselExampleDark" className="carousel carousel-dark slide" data-bs-ride="carousel">
                        <div className="carousel-inner my-3">
                            <div className="carousel-item active" data-bs-interval="10000">
                                <img src={comment} className="d-block" alt="..." />
                                <div className="carousel-caption d-md-block">
                                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Harum similique eius error necessitatibus porro optio quos aut tenetur quisquam non.</p>
                                    <h5 className='py-5'>UX_BABA</h5>
                                </div>
                            </div>
                            <div className="carousel-item" data-bs-interval="2000">
                                <img src={comment} className="d-block" alt="..." />
                                <div className="carousel-caption d-md-block">
                                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Harum similique eius error necessitatibus porro optio quos aut tenetur quisquam non.</p>
                                    <h5 className='py-5'>UX_BABA</h5>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <img src={comment} className="d-block" alt="..." />
                                <div className="carousel-caption d-md-block">
                                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Harum similique eius error necessitatibus porro optio quos aut tenetur quisquam non.</p>
                                    <h5 className='py-5'>UX_BABA</h5>
                                </div>
                            </div>
                        </div>
                        <div className='px-5'>
                            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
                                <span className="carousel-control-next-icon " aria-hidden="true"></span>
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Clients;